import { render, staticRenderFns } from "./ProductTabSelection.vue?vue&type=template&id=3b79130a&scoped=true&"
import script from "./ProductTabSelection.vue?vue&type=script&lang=js&"
export * from "./ProductTabSelection.vue?vue&type=script&lang=js&"
import style0 from "./ProductTabSelection.vue?vue&type=style&index=0&id=3b79130a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b79130a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b79130a')) {
      api.createRecord('3b79130a', component.options)
    } else {
      api.reload('3b79130a', component.options)
    }
    module.hot.accept("./ProductTabSelection.vue?vue&type=template&id=3b79130a&scoped=true&", function () {
      api.rerender('3b79130a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/permissions/ProductTabSelection.vue"
export default component.exports